<!--  -->
<template>
  <div>
    <div style="text-align:center;margin-bottom: 10px;">
      <div style="color:#F56C6C;font-size: 18px;">请确保当前手机扫码员工为</div>
      <div style="color:#F56C6C;font-size: 18px;margin-top: 15px;">{{ itemobj.corp_user_name }}({{ itemobj.corp_name }})</div>
      <div style="color:#F56C6C;font-size: 18px;margin-top: 15px;">{{ itemobj.employee_no }}</div>
    </div>
    <div
      v-loading="qrcodedialogloading"
      class="qr_boxr"
      element-loading-background="transparent"
      style="text-algin:center"
    >
      <img
        :src="qrcode_url"
        alt=""
        style="width:200px"
      >
    </div>
    <div
      v-if="qrcode_url!=''"
      class="codebox"
    >
      <div style="flex-shrink: 0;">验证码：</div>
      <el-input
        v-model="code"
        style="width: 625px;"
        placeholder="若登录发现手机接收到验证码，请10秒后在填入验证码，点击确认，否则扫码完毕关闭弹窗即可"
      />
    </div>
    <div
      v-if="qrcode_url!=''"
      class="onc_box"
    ><el-button
      type="primary"
      @click="sumbitr"
    >确定</el-button></div>
  </div>
</template>

<script>
import { loginVerifyCode } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      itemobj: {},
      qrcode_url: '',
      code: '',
      qrcodedialogloading: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    async sumbitr() {
      if (this.code === '') {
        this.$message({
          type: 'error',
          message: '请输入验证码'
        })
        return
      }
      const data = await loginVerifyCode({
        code: this.code,
        employee_no: this.itemobj.employee_no
      })
      this.$message({
        type: 'success',
        message: '操作成功'
      })
      this.code = ''
      this.$emit('updataer')
      console.log('data', data)
    },
    send(item) {
      console.log('item', item)
      this.itemobj = item.data
      this.qrcode_url = item.data.qrcode_url
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.qr_boxr {
  text-align: center;
}
.codebox {
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: center;
}
.onc_box {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
